// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__2ZTiQ","label":"styles_label__2TfXA","input":"styles_input__3oqUI","error":"styles_error__1-GXC"};